import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/FramersBooth.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { arrow } from "../../constant";
import Apple from "../../assets/img/booking/garder_town/apple.png";
import google from "../../assets/img/booking/garder_town/google.png";
// import paypal from "../../assets/img/booking/garder_town/paypal.png";
import mastercard from "../../assets/img/booking/garder_town/mastercard.png";
import visa from "../../assets/img/booking/garder_town/visacard.png";
import StripeForm from "../../Components/PaymentMethod/StripeForm";
import { dollar } from "../../constant";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import {
	bookMemberShipPost,
	GetBookingDates,
	GetMembership,
	GetMembershipLocation,
	PostMembershipById,
} from "../../network/Network";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import GoogleMapComp from "../../Components/Map/GoogleMap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function FramersBooth() {
	const [farmerMembership, setFarmerMembership] = useState([]);
	const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
	const new_date = new Date().toISOString().slice(0, 10);
	const [campingMembership, setCampingMembership] = useState([]);
	const Token = useSelector((state) => state?.AuthReducer?.token);
	const [locationMemb, setLocationMemb] = useState(null);
	const [locationVal, setLocatinVal] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [gardenMembership, setGardenMembership] = useState([]);
	const [camping, setCamping] = useState();
	const [state, setState] = useState({
		membership_id: 9,
		is_family_membership: "",
		// other_memberships_included: "",
		price: gardenMembership?.price,
		booking_date: "",
		booking_time: "",
	});
	const [loading, setLoading] = useState(false);
	const [btnLoading, setBtnLoading] = useState(false);
	const [singleCamping, setSingleCamping] = useState();
	const [checkBookingDates, setCheckBookingDates] = useState([]);

	const styling = {
		marginTop: "10px",
		width: "100%",
	};
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	// Get Membership by id
	useEffect(() => {
		setLoading(true);
		PostMembershipById(9)
			.then((res) => {
				// console.log(res);
				setLoading(false);
				setFarmerMembership(res?.data);
				// dispatch(AllCategoriesData(res?.data));
			})
			.catch((err) => {
				setLoading(false);
				// console.log(err);
			});
	}, []);

	useEffect(() => {
		setLoading(true);
		GetMembership()
			.then((res) => {
				setLoading(false);
				setCamping(res.data);
				// setGardenMembership(res?.data);
			})
			.catch((err) => {
				setLoading(false);
				// console.log(err);
			});
	}, []);

	useEffect(() => {
		setLoading(true);
		GetMembershipLocation()
			.then((res) => {
				setLoading(false);
				setLocationMemb(res?.data?.response?.data);
				setLocatinVal(res?.data?.response?.data[0]?.id);
				FindLocation(res?.data?.response?.data[0]?.id);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, []);

	const extractDate = (dateString) => {
		const regex = /[a-zA-Z]{3} [a-zA-Z]{3} \d{2} \d{4}/;
		const match = dateString?.toString()?.match(regex);
		const inputDate = new Date(match ? match[0] : "");
		const outputDate = `${inputDate.getFullYear()}-${
			inputDate.getMonth() + 1
		}-${inputDate.getDate()}`;
		return outputDate;
	};

	const PlaceOrderHandler = (e, stripe_token) => {
		e.preventDefault();
		setBtnLoading(true);
		if (!state?.booking_date || !state?.booking_time || !locationVal) {
			toast.error("Plese fill all compulsory fields");
			setBtnLoading(false);
		} else {
			const { membership_id, booking_date, booking_time } = state ?? {};
			let sendData = {
				membership_id: membership_id,
				price: farmerMembership?.price,
				_token: stripe_token,
				booking_date: extractDate(booking_date),
				booking_time: booking_time,
				farm_location_id: locationVal,
				type: "booking",
			};
			bookMemberShipPost(sendData, Token)
				.then((res) => {
					setBtnLoading(false);
					toast.success(
						"Farmer’s Booth Space booking has been done successfully",
					);
					GetBookingDates(campingMembership?.id, locationVal);
					navigate("/");
				})
				.catch((err) => {
					// toast.error("An error occured during booking");
					toast.error(`${err?.response?.data?.message}`);
					console.log(err?.response?.data, "booking error");
					setBtnLoading(false);
					// navigate('/');
					// console.log(err);
				});
		}
	};

	const [mapData, setMapData] = useState();
	const FindLocation = (value = locationVal) => {
		let filterMapData = locationMemb?.filter((val) => val?.id == value);
		if (filterMapData?.length > 0) {
			setMapData(filterMapData[0]);
			// return filterMapData[0]
		}
	};

	useEffect(() => {
		FindLocation(locationVal);
	}, [locationVal]);

	useEffect(() => {
		const membershipId = 1,
			locationId = 1;
		setLoading(true);
		GetBookingDates(farmerMembership?.id, locationVal)
			.then((res) => {
				const result = res?.data?.response?.data;
				const dates = result?.map((date) => {
					return date?.booking_date;
				});

				setCheckBookingDates(dates);
				setState({ ...state, booking_date: "" });
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, [locationVal, farmerMembership]);

	console.log(farmerMembership, "Booking");

	// Define the array of disabled dates (replace this with your specific dates)
	const disabledDates = ["2023/08/29", "2023/08/30", "2023/08/28"];

	// // Function to check if a date is disabled
	// const isDateDisabled = (date = "") => {
	// 	const formattedDate = date?.toISOString()?.split("T")[0]; // Convert date to "YYYY-MM-DD" format
	// 	return checkBookingDates.includes(formattedDate);
	// };

	// Function to check if a date should be disabled
	// const isDateDisabled = (date) => {
	// 	return !checkBookingDates.some(
	// 		(disabledDate) =>
	// 			new Date(disabledDate).toDateString() === date.toDateString(),
	// 	);
	// };

	// Function to check if a date should be disabled
	const isDateDisabled = (date = "") => {
		const formattedDate = date.toISOString().split("T")[0]; // Convert date to "YYYY-MM-DD" format
		return !checkBookingDates.includes(formattedDate);
		// return !checkBookingDates.some(
		// 	(disabledDate) =>
		// 		new Date(disabledDate).toDateString() === date.toDateString(),
		// );
	};

	return (
		<>
			<Header />
			<MainBanner name={"Framers Booth Space"} />
			<section className="Framers-page">
				<div className="container">
					{loading ? (
						<Skeleton count={5} />
					) : (
						<div>
							<div className="Book_range_center">
								<h2 className="main-Title">{farmerMembership?.heading} </h2>
								<h3 className="priceRate">
									<img className="" src={dollar} alt="" />
									<span className="ml-2">
										{state?.other_memberships_included
											? `${
													parseInt(singleCamping?.price) +
													parseInt(farmerMembership?.price)
											  }`
											: farmerMembership?.price}
									</span>
								</h3>
							</div>
							<p className="main-para">{farmerMembership?.description}</p>
							<ActionButton />
							<div className="formContainer">
								<p className="sub-title">Booking Details</p>
								<div className="row">
									<div className="col-lg-6">
										<p className="sub-title-sm">Select the Date</p>
										{/* <input
											min={new_date}
											onKeyDown={(e) => e.preventDefault()}
											onChange={(e) => {
												setState({ ...state, booking_date: e.target.value });
											}}
											type="date"
										/> */}

										{/* <input
											min={new_date}
											onChange={(e) => {
												const selectedDate = e.target.value;
												if (!isDateDisabled(selectedDate)) {
													setState({ ...state, booking_date: selectedDate });
												}
											}}
											type="date"
										/> */}

										<DatePicker
											selected={state.booking_date}
											onChange={(date) =>
												setState({ ...state, booking_date: date })
											}
											filterDate={isDateDisabled}
											dateFormat="MMMM d, yyyy"
											placeholderText={"mm, dd, yyyy"}
											minDate={new Date()}
										/>
									</div>
									<div className="col-lg-6">
										<p className="sub-title-sm">Select Check-in Time</p>
										<input
											onChange={(e) => {
												setState({ ...state, booking_time: e.target.value });
											}}
											type="time"
										/>
									</div>

									<div className="col-lg-6">
										<p className="sub-title-sm">Select location on farm</p>
										{/* <select
											onChange={(e) => {
												setLocatinVal(e.target.value);
												FindLocation(e.target.value);
											}}
										>
											{locationMemb?.map((item, index) => {
												return (
													<>
														<option
															key={index + 8561}
															value={item?.id}
															{...(locationVal === item?.id ? "selected" : "")}
														>
															{item?.name}
														</option>
													</>
												);
											})}
										</select> */}

										<select
											onChange={(e) => {
												setLocatinVal(e.target.value);
												FindLocation(e.target.value);
											}}
											defaultValue={locationVal}
										>
											{locationMemb?.map((item, index) => (
												<option
													key={index + 8561}
													value={item?.id}
													// selected={locationVal === item?.id ? true : false}
												>
													{item?.name}
												</option>
											))}
										</select>
									</div>
									{locationVal ? (
										<div className="col-lg-12">
											<div style={{ height: "100px", width: "100%" }}>
												<GoogleMapComp
													mapData={mapData}
													locationVal={locationVal}
												/>
											</div>
										</div>
									) : null}
								</div>
								{Token ? (
									<>
										<p className="sub-title">Payment Details </p>
										<StripeForm
											styling={styling}
											paynow="SUBMIT"
											PaymentHandler={PlaceOrderHandler}
											loading={btnLoading}
										/>
									</>
								) : (
									<>
										<p className="sub-title">Payment Details </p>
										<div className="camping_btn">
											<button
												onClick={() => {
													navigate("/login");
												}}
												className="btn"
											>
												Sign In
												<img src={arrow} className="image-fluid pl-2" />
											</button>
											<button
												onClick={() => {
													navigate("/signup");
												}}
												className="btn secondbtn"
											>
												Create An Account
												<img src={arrow} className="image-fluid pl-2" />
											</button>
										</div>
									</>
								)}
							</div>
						</div>
					)}
				</div>
			</section>
			<Footer />
		</>
	);
}

export default FramersBooth;
